import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';
import { requestBibliotecaRepositorios } from '../services/requests';

export default function CardBiblioteca() {
	const [cards, setCards] = useState([]);

	useEffect(() => {
		async function fetchRepos() {
			try {
				const repos = await requestBibliotecaRepositorios();
				const cardsData = Array.isArray(repos)
					? repos.map((repo) => ({
							id: repo.id,
							label: repo.nome,
							icon: repo.icone,
						}))
					: [];
				setCards(cardsData);
			} catch (e) {
				console.error(
					'Erro ao carregar repositórios da biblioteca:',
					e,
				);
				setCards([]);
			}
		}
		fetchRepos();
	}, []);

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />

			<div className='sm:top-[80px] mt-[80px] pb-4 bg-[#f0f4f8] w-full'>
				<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
					<div className='px-[2px] py-[18px]'>
						<p
							className='mx-auto md:mx-10 text-[#004A80] text-center font-semibold text-[32px] leading-[120%] mb-12 mt-14'
							style={{
								fontFamily: 'Inter, sans-serif',
								letterSpacing: '0%',
							}}>
							Biblioteca SUBHUE
						</p>
					</div>
				</div>
			</div>

			<main className='flex-grow flex items-center justify-center mt-10 sm:mt-0 mb-8 w-full'>
				<div className='grid grid-cols-2 gap-4 px-4 w-full max-w-6xl sm:px-0 sm:flex sm:flex-row sm:flex-wrap sm:gap-8 sm:justify-center'>
					{cards.map((card) => (
						<Link
							key={card.id}
							to={`/biblioteca/${card.id}`}
							className='flex flex-col items-center justify-between w-full h-[200px] bg-[#13335A] rounded-md shadow-md hover:scale-105 transition-transform duration-200 sm:w-[200px] sm:h-[240px]'
							style={{ textDecoration: 'none' }}>
							<div className='flex flex-col items-center justify-center h-[140px] w-full pt-6 sm:h-[160px] sm:pt-8'>
								{card.icon ? (
									<img
										src={card.icon}
										alt={card.label}
										className='w-[48px] h-[40px] object-contain mx-auto sm:w-[65px] sm:h-[53px]'
									/>
								) : (
									<div className='w-[48px] h-[40px] sm:w-[65px] sm:h-[53px] bg-white/10 rounded' />
								)}
							</div>
							<div className='h-[3px] w-[80%] bg-white' />
							<div className='flex flex-col items-center justify-end h-[60px] w-full sm:h-[70px]'>
								<p className='font-medium text-center text-white text-[13px] mb-4 sm:text-[14px] sm:mb-5'>
									{card.label}
								</p>
							</div>
						</Link>
					))}
				</div>
			</main>
		</div>
	);
}
